export default __webpack_public_path__ + "static/media/war2.81edafd8.png";